<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import UiGroup from '@/components/UiGroup.vue'
import UiList from '@/components/UiList.vue'
import UiRow from '@/components/UiRow.vue'
import { useSharingEditor } from '@/composables/useSharingEditor'
import { sharingPath } from '@/settings/sharingNav'

// The form to block somebody by username; back on the list afterwards.
const { t } = useI18n()
const router = useRouter()
const editor = useSharingEditor()
const username = ref('')
const submitting = ref(false)

async function submit(): Promise<void> {
  submitting.value = true
  try {
    if (await editor.block(username.value)) await router.replace(sharingPath('users'))
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <form @submit.prevent="submit">
    <UiGroup>
      <UiList>
        <UiRow as="label" :label="t('settings.blocked.username')">
          <input
            v-model="username"
            class="ui-input"
            required
            placeholder="@someone"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            :aria-label="t('settings.blocked.username')"
          />
        </UiRow>
      </UiList>
    </UiGroup>
    <UiGroup>
      <UiList>
        <UiRow as="button" type="submit" class="action" :disabled="submitting" data-testid="block-submit">
          {{ submitting ? t('settings.blocked.blocking') : t('settings.blocked.block') }}
        </UiRow>
      </UiList>
    </UiGroup>
  </form>
</template>

<style scoped>
.action {
  width: 100%;
  border: 0;
  background: none;
  color: var(--tg-link-color);
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.action:disabled {
  opacity: 0.6;
  cursor: default;
}
</style>
